import React, { useState } from "react";

import { MTable } from "../v3";
import { purchaseOrderColumnHeaders } from "../../pages/purchaseOrders/constants";
import { usePersistedTableState } from "../../hooks/usePersistedTableState";

export const PurchaseOrderList = () => {
  // Remembered per visit: Back restores these, forward navigation starts from the defaults.
  const {
    searchText,
    setSearchText,
    paginationModel: paginationState,
    setPaginationModel: setPaginationState,
  } = usePersistedTableState({
    tableId: "purchase-orders",
    defaults: {},
  });
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSearchChange = (searchValue) => {
    setSearchText(searchValue);
    // fetch data here
  };

  const handlePaginationChange = (model) => {
    setPaginationState(model);
    // fetch data here
  };

  const onPurchaseOrderClick = (order) => {
    // TODO: Implement the logic to navigate to the purchase order details page
    // navigate(`/purchase-orders/${order.id}`);
    console.log("Order clicked:", order.id);
  };

  const rows = purchaseOrders.map((order, index) => ({
    id: order.id,
    sl: index + 1 + paginationState.page * paginationState.pageSize,
    orderNo: order.orderNo,
    orderDate: order.orderDate,
    requiredDate: order.requiredDate,
    vendorName: order.vendorName,
    assigneeName: order.assigneeName,
    totalAmount: order.totalAmount,
  }));

  return (
    <MTable
      placeholder="search order"
      searchText={searchText}
      // onSearchChange={onSearchChange}
      onSearchChange={handleSearchChange}
      showSearchBar
      // Export data
      showExportButton // TODO: Implement permission
      // Table data
      columnHeaders={purchaseOrderColumnHeaders}
      tableRows={rows}
      rowCount={purchaseOrders.length || 0}
      loading={loading}
      paginationModel={paginationState}
      onPaginationChange={handlePaginationChange}
      onRowClick={onPurchaseOrderClick}
    />
  );
};
